// NOTE: This file is only for 📖 Storybook & ✅ Tests
function DebugThrow(props: { error?: Error }): never {
  throw props?.error || Error('💥 Error thrown in render 💥');
}

export { DebugThrow };
